import { ArrowRight } from "lucide-react";
import { clickCta } from "@/lib/analytics";
import { cn } from "@/lib/utils";

interface HeroActionsProps {
  primaryAction?: { label: string; onClick?: () => void };
  secondaryAction?: { label: string; href?: string; onClick?: () => void };
  className?: string;
}

export function HeroActions({ primaryAction, secondaryAction, className }: HeroActionsProps) {
  if (!primaryAction && !secondaryAction) return null;

  return (
    <div className={cn("flex flex-wrap items-center justify-center gap-3", className)}>
      {primaryAction && (
        <button
          onClick={() => {
            clickCta(primaryAction.label, "hero");
            primaryAction.onClick?.();
          }}
          className="group inline-flex cursor-pointer items-center gap-2 rounded-full bg-gradient-to-r from-brand-blue to-[#ec4899] px-6 py-3 text-sm font-semibold text-white transition-all hover:opacity-90 active:scale-[0.98]"
        >
          {primaryAction.label}
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </button>
      )}
      {secondaryAction && (
        <a
          href={secondaryAction.href ?? "#"}
          onClick={(event) => {
            if (!secondaryAction.href) event.preventDefault();
            clickCta(secondaryAction.label, "hero");
            secondaryAction.onClick?.();
          }}
          className="inline-flex items-center rounded-full border border-border bg-background px-6 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-accent"
        >
          {secondaryAction.label}
        </a>
      )}
    </div>
  );
}
